<div class="ro-invoice-container">
    <div class="w-100" *ngIf="loading">
        <div class="pay-invoice-empty">
            <img src="assets/images/landing-page/loading-more.svg" alt="Loader" />
        </div>
    </div>
    <div *ngIf="!paymentMethodEnabledFlag" class="pay-invoice-container">
        <div class="card-container w-100">
            <div class="head-sec p-3 placeholder-head">
                <div class="head-sec-view-lt w-50" style="display: inline-block; vertical-align: top;">Payment Options</div>
            </div>
            <div class="placeholder-content text-center">
                <div class="placeholder-icon-payment"></div>
                <div class="placeholder-info">
                    Payment options are currently disabled. To enable them, <span class="new-link cursor" (click)="navPaymentSettings()">tap here</span>.
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading && paymentMehodsFlag && paymentMethodEnabledFlag" class="pay-invoice-container">
        <div class="card-container w-100">
            <div class="head-sec p-3 placeholder-head">
                <div class="head-sec-view-lt w-50" style="display: inline-block; vertical-align: top;">Payment Options</div>
            </div>
            <div class="placeholder-content text-center">
                <div class="placeholder-icon-payment"></div>
                <div class="placeholder-info">Payment options are currently disabled.</div>
            </div>
        </div>
    </div>
    <div class="pay-invoice-container" *ngIf="!loading && payInvoiceFlag && !paymentMehodsFlag && paymentMethodEnabledFlag">
        <div class="">
            <div class="card-container w-100">                
                <div class="head-sec p-3">

                    <div class="head-sec-view-lt w-50" style="display: inline-block; vertical-align: top;">
                        Pay Invoice
                    </div>
                    <div *ngIf="payCheque || payAccount || payCash || payOtherAccount" class="head-sec-view-rt w-50" style="display: inline-block; vertical-align: top;">

                        <button 
        pButton
        pRipple
        type="button"
        (click)="savePayInvoice()"
        icon="pi pi-check"
        iconPos="right"
        label="Save"
        [ngClass] = "{ 'setOpacity5' : saveROchequeFlag }"
        class="float-right payment-method-btn"
      ></button>

                        <button *ngIf="editSection"
        pButton
        pRipple
        type="button"
        (click)="savePayInvoiceCancel()"
        icon="pi pi-times"
        iconPos="right"
        label="Cancel"
        [ngClass] = "{ 'setOpacity5' : saveROchequeFlag }"
        class="float-right  payment-method-cancel-btn mr-4"
      ></button>
                    </div> 
                    <div *ngIf="payCard" class="head-sec-view-rt w-50" style="display: inline-block; vertical-align: top;">
                
                       

                        <button 
        pButton
        pRipple
        type="button"
        (click)="saveCardPayInvoice()"
        icon="pi pi-check"
        iconPos="right"
        label="PAY"
        [ngClass] = "{ 'setOpacity5' : saveROchequeFlag }"
        class="float-right payment-method-btn"
      ></button>

                        <button *ngIf="editSection"
        pButton
        pRipple
        type="button"
        (click)="savePayInvoiceCancel()"
        icon="pi pi-times"
        iconPos="right"
        label="Cancel"
        [ngClass] = "{ 'setOpacity5' : saveROchequeFlag }"
        class="float-right  payment-method-cancel-btn mr-4"
      ></button>

        <img class="stripe-logo-pay" src="assets/images/repair-order/stripe-logo.png">

    </div>
                    

                    

                     
                </div>
            </div>
            <div class="pl-3 pr-3">
                <div class="label-sec payment-method-bg">Select Payment Method</div>
                <div class="card-container w-100"> 
                    <div class="card-container-left">              
                        <div *ngIf="showCheckMethod" title="Check" class="card-sec cheque cursor" [ngClass]="{ 'active' : payCheque }" (click)="tapPayment('1')">
                            <span class="mt-2">Check</span>
                        </div>
                        <div *ngIf="showCashMethod" title="Cash" class="card-sec cash cursor" [ngClass]="{ 'active' : payCash }" (click)="tapPayment('2')">
                            <span class="mt-2">Cash</span>
                        </div>
                        <div *ngIf="showCardMethod" title="Credit Card" class="card-sec card cursor" [ngClass]="{ 'active' : payCard }"  (click)="tapPayment('3')">
                            <span class="mt-2">Credit Card</span>
                        </div>
                        <div *ngIf="showAccountMethod" title="On Account" class="card-sec account cursor" [ngClass]="{ 'active' : payAccount }" (click)="tapPayment('4')">
                            <span class="mt-2">On Account</span>
                        </div> 
                        <div *ngIf="showOtherMethod" title="Other" class="card-sec other cursor" [ngClass]="{ 'active' : payOtherAccount }" (click)="tapPayment('5')">
                            <span class="mt-2">Other</span>
                        </div>
                    </div> 
                    <div class="card-container-right">
                         <span class="total-label">Pay Amount: <span class="total">${{totalInvoice}}</span></span>
                         <span class="def-pay-sta" *ngIf="!payCheque && !payCash && !payCard && !payAccount && !payOtherAccount">
                            <div class="paysta">Payment Status</div>
                            <div class="pay-cheque-opt-view">
                                <span class="unpaid">Unpaid</span>                                    
                            </div>                            
                         </span>                        
                    </div>              
                </div>
            </div>
        </div>
         <div class="mt-4 pl-3 pr-3" *ngIf="payCheque">
            <div class="pay-cheque-form-container w-100">
                <div class="pay-cheque-left">
                    <div class="mb-2">                        
                        <div class="w-50 pr-4" style="display: inline-block;vertical-align: top;">
                            <span class="pay-lable bank-name-bg">Bank Name</span>
                            <p-dropdown appendTo='body' [options]="backNameList" [(ngModel)]="bankID" optionLabel="name" resetFilterOnHide="true"
                                (onChange)="changeDD($event)"
                                optionValue="id" placeholder="Select Bank" [virtualScroll]="false" [itemSize]="5" [filter]="true">
                                <ng-template let-contact pTemplate="item">
                                    <div class="option-item" *ngIf="contact.id == 0" (click)="serviceAction('add');">
                                        <div><span style="color: #469073;">{{contact.name}}</span></div>
                                    </div>                                    
                                    <div *ngIf="contact.id != 0" class="option-item">{{contact.name}}</div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                        <div class="w-50" style="display: inline-block;vertical-align: top;">
                            <span class="pay-lable cheque-label-bg">Check#</span>
                            <input (input)=changeDD($event) (keypress)="isNumberKey($event)" class="input-box" [(ngModel)]="chequeNo" placeholder="Enter Check#" pInputText type="text">
                        </div>
                    </div>
                    <div class="mb-2 mt-4">
                        <span class="pay-lable attach-picture-label-bg">Attach picture of Check</span> 
                        <div  class="attachment-row black-theme-row newupload-white attachment-welcome-message-right" style="height: 103px;display: inline-block;padding: 0 !important">
                
                            <app-attachment-view paymentMethodEnabledFlag="true" *ngIf="editSection && invoiceCheckList && invoiceCheckList.length>0 && invoiceCheckList[0].attachments.length > 0" [action]="invoiceCheckList[0].EditAttachmentAction" [access]="pageAccess" [attachments]="invoiceCheckList[0].attachmentItems" (attachmentAction)="attachmentAction($event)" style="height: 103px;display: inline-block;padding: 0 !important;vertical-align: top;"></app-attachment-view>
                            <app-file-attachment *ngIf="editPostUpload" class="attachment-file" [action]="manageAction" [apiData]="postEditApiData" [attachmentItems]="attachmentItems" (uploadedItems)="editAttachments($event)" style="height: 103px;display: inline-block;padding: 0 !important;vertical-align: top;"></app-file-attachment>

                        </div>
                    </div>
                </div>
                <div class="pay-cheque-right">
                    <span class="pay-lable payment-option-label-bg" style="width: 144px;display: inline-block;">Payment Option</span>
                    <span class="pay-cheque-opt cursor">
                        <span  class="spanlt unpaid" [ngClass]="{ 'active' : payChequeUnPaid }" (click)="payChequeOption('0')">Unpaid</span>
                        <span class="lt-border spanrt paid" [ngClass]="{ 'active' : payChequePaid }" (click)="payChequeOption('1')">Paid</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="mt-4 pl-3 pr-3" *ngIf="payCash">
            <div class="pay-cheque-form-container w-100">
                 <div class="pay-cheque-left"></div>
                 <div class="pay-cheque-right">   
                    <span class="pay-lable payment-option-label-bg" style="width: 144px;display: inline-block;">Payment Option</span>
                    <span class="pay-cheque-opt cursor">
                        <span  class="spanlt unpaid" [ngClass]="{ 'active' : payChequeUnPaid }" (click)="payChequeOption('0')">Unpaid</span>
                        <span class="lt-border spanrt paid" [ngClass]="{ 'active' : payChequePaid }" (click)="payChequeOption('1')">Paid</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="mt-4 pl-3 pr-3" *ngIf="payAccount">
            <div class="pay-cheque-form-container w-100">
                <div class="pay-cheque-left">
                    <span class="pay-lable payment-terms-label-bg pb-2" style="width: 144px;display: inline-block;">Payment Terms</span>
                    <span class="payment-sh-sec payment-sh-sec-bg" >{{paymentDays}}</span>
                </div>
                <div class="pay-cheque-right">
                    <span class="pay-lable payment-option-label-bg" style="width: 144px;display: inline-block;">Payment Option</span>
                    <span class="pay-cheque-opt cursor">
                        <span  class="spanlt unpaid" [ngClass]="{ 'active' : payChequeUnPaid }" (click)="payChequeOption('0')">Unpaid</span>
                        <span class="lt-border spanrt paid" [ngClass]="{ 'active' : payChequePaid }" (click)="payChequeOption('1')">Paid</span>
                    </span>
                </div>               
            </div>
        </div>
        <div class="mt-4 pl-3 pr-3" *ngIf="payCard" style="position: relative;">            
            <div class="pay-cheque-form-container w-100">
                <app-stripe-cards [access]="cardAccess" [cardAction]="cardAction" [email]="shopEmail" [shopId]="shopId" [stripeData]="showCardItemData" (stripeCardCompoentRef) = "stripeCardPageRef = $event" (stripeInvoicdCardCallBack)="stripeInvoicdCardCallBack($event)"></app-stripe-cards>                               
            </div>
        </div>
        <div class="mt-4 pl-3 pr-3" *ngIf="payOtherAccount">
            <div class="pay-cheque-form-container w-100">
                <div class="pay-cheque-left">
                    <div class="mb-2">                        
                        <div class="w-50 pr-4" style="display: inline-block;vertical-align: top;">
                            <span class="pay-lable other-acc-name-bg">Other Payment Option</span>
                            <input type="text" pInputText class="input-box cursor" readonly="true" placeholder="Select"
                            (click)="onChangeSelection('other-payment')"                                              
                            maxlength="" />
                            <div (click)="onChangeSelection('other-payment')" class="ro-input-down-arrow cursor"><span class="icon"></span></div>
                            
                            <div *ngIf="filteredOtherPayments?.length > 0" class="selected-items">
                                <div *ngFor="let item of filteredOtherPayments; let t=index" class="tag-text pay-text">
                                    <span>{{item}}</span>
                                    <i class="material-icons tag-close" (click)="disableOtherPaymentSelection(t)">close</i>
                                </div>
                            </div>

                        </div>                        
                    </div>                    
                </div>
                <div class="pay-cheque-right">
                    <span class="pay-lable payment-option-label-bg" style="width: 144px;display: inline-block;">Payment Option</span>
                    <span class="pay-cheque-opt cursor">
                        <span  class="spanlt unpaid" [ngClass]="{ 'active' : payChequeUnPaid }" (click)="payChequeOption('0')">Unpaid</span>
                        <span class="lt-border spanrt paid" [ngClass]="{ 'active' : payChequePaid }" (click)="payChequeOption('1')">Paid</span>
                    </span>
                </div>
            </div>
        </div>
    </div>    
   <div *ngIf="!loading && !paymentMehodsFlag && paymentMethodEnabledFlag && paymentInvoiceCheckFlag && ((invoiceCheckList && invoiceCheckList.length>0) || (invoiceonAccList && invoiceonAccList.length>0) || (invoiceCardList && invoiceCardList.length>0) || (invoiceOtherAccList && invoiceOtherAccList.length>0) || (invoiceCashList && invoiceCashList.length>0))" class="pay-invoice-container">
        <div >
            <div class="card-container w-100">                
                <div class="head-sec head-sec-view mb-2 w-100" [ngClass]="{ 'head-sec-normal' : !preview, 'head-sec-preview' : preview }">
                    <div class="head-sec-view-lt w-50" style="display: inline-block; vertical-align: top;">
                        Invoice Payment Details
                    </div>
                    <div *ngIf="!preview && ((invoiceCheckList && invoiceCheckList.length>0) || (invoiceonAccList && invoiceonAccList.length>0) || (invoiceOtherAccList && invoiceOtherAccList.length>0) || (invoiceCashList && invoiceCashList.length>0))" class="head-sec-view-rt w-50" (click)="editPayInvoice()" style="display: inline-block; vertical-align: top;">
                        <div class="pay-lable edit-bg cursor">Edit</div>
                    </div>                    
                </div>               
            </div>
            <div>
                <div class="w-100" *ngIf="invoiceCheckList && invoiceCheckList.length>0">
                    <div class="payment-detail-box" *ngFor="let check of invoiceCheckList">
                         <div class="w-100 pb-4">
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Payment Method</div>
                            <div class="payment-sh-sec">Check</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Bank Name</div>  
                            <div class="payment-sh-sec" title="{{check.bankName}}">{{check.bankName == '' ? '-' : check.bankName}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c3">
                            <div class="label-sec">Check Number</div>                        
                            <div class="payment-sh-sec">{{check.chequeNo == '' ? '-' : check.chequeNo }}</div>
                        </div>
                        <div class="pay-w-col pay-w-c4">
                            <div class="label-sec">Picture of check</div>                        
                            <div class="payment-sh-sec">
                                <div *ngIf="!check.attachmentLoading" id="attachment-v4"
                                        class="reference-info user-info">
                                        <app-attachment-view class="more-attachment-lt" paymentMethodEnabledFlag="true"
                                            [dynamicGid]="'000'+previewDynamicId+check.id" *ngIf="!check.attachmentLoading"
                                            [loading]="check.attachmentLoading" [action]="action"
                                            [attachments]="check.attachments"></app-attachment-view>
                                </div>
                                <div *ngIf="check.attachmentLoading">-</div>
                            </div>
                        </div>
                        <div class="pay-w-col pay-w-c8">
                            <div class="label-sec">Amount</div>                        
                            <div class="payment-sh-sec">${{check.paidAmount}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c8">
                            <div class="label-sec">Paid Status</div>                        
                            <div class="pay-cheque-opt-view">
                                <span [ngClass]="{ 'paid' : check.paymentStatus == 2, 'unpaid' : check.paymentStatus != 2 }">{{ check.paymentStatus == 2 ? 'Paid' : 'Unpaid' }}</span>                                    
                            </div>
                        </div>
                        </div>
                        <div class="w-100">
                            <div class="pay-w-col pay-w-c7">
                                <div class="label-sec">Paid On</div>                        
                                <div class="payment-sh-sec">{{check.paidOnDate}}</div>
                            </div>
                            <div class="pay-w-col pay-w-c7">
                                <div class="label-sec">Type</div>                        
                                <div class="payment-sh-sec">{{check.invoiceType != undefined && check.invoiceType != '' ? check.invoiceType : 'Price Invoice'}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100" *ngIf="invoiceCashList && invoiceCashList.length>0">
                    <div class="payment-detail-box" *ngFor="let cash of invoiceCashList">
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Payment Method</div>
                            <div class="payment-sh-sec">Cash</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Amount</div>                        
                            <div class="payment-sh-sec">${{cash.paidAmount}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid Status</div>                        
                            <div class="pay-cheque-opt-view">
                                <span [ngClass]="{ 'paid' : cash.paymentStatus == 2, 'unpaid' : cash.paymentStatus != 2 }">{{ cash.paymentStatus == 2 ? 'Paid' : 'Unpaid' }}</span>                                    
                            </div>
                        </div>
                         <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid On</div>                        
                            <div class="payment-sh-sec">{{cash.paidOnDate}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Type</div>                        
                            <div class="payment-sh-sec">{{cash.invoiceType != undefined && cash.invoiceType != '' ? cash.invoiceType : 'Price Invoice'}}</div>
                        </div>
                    </div>
                </div>

                <div class="w-100" *ngIf="invoiceonAccList && invoiceonAccList.length>0">
                    <div class="payment-detail-box" *ngFor="let onacc of invoiceonAccList">
                        <div class="pay-w-col pay-w-c6" >
                            <div class="label-sec">Payment Method</div>
                            <div class="payment-sh-sec">On Account</div>
                        </div>
                        <div class="pay-w-col pay-w-c6" >
                            <div class="label-sec">Payment Terms</div>  
                            <div class="payment-sh-sec" title="{{onacc.onAccountDays}}">{{onacc.onAccountDays}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c6" >
                            <div class="label-sec">Amount</div>                        
                            <div class="payment-sh-sec">${{onacc.paidAmount}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c6" >
                            <div class="label-sec">Paid Status</div>                        
                            <div class="pay-cheque-opt-view">
                                <span [ngClass]="{ 'paid' : onacc.paymentStatus == 2, 'unpaid' : onacc.paymentStatus != 2 }">{{ onacc.paymentStatus == 2 ? 'Paid' : 'Unpaid' }}</span>                                    
                            </div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid On</div>                        
                            <div class="payment-sh-sec">{{onacc.paidOnDate}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c6">
                            <div class="label-sec">Type</div>                        
                            <div class="payment-sh-sec">{{onacc.invoiceType != undefined && onacc.invoiceType != '' ? onacc.invoiceType : 'Price Invoice'}}</div>
                        </div>
                    </div>
                </div>

                <div class="w-100" *ngIf="invoiceOtherAccList && invoiceOtherAccList.length>0">
                    <div class="payment-detail-box" *ngFor="let otheracc of invoiceOtherAccList">
                        <div class="pay-w-col pay-w-c8" >
                            <div class="label-sec">Payment Method</div>
                            <div class="payment-sh-sec">Other</div>
                        </div>
                        <div class="pay-w-col pay-w-c9" >
                            <div class="label-sec">Payment Option</div>  
                            <div class="payment-sh-sec" title="{{otheracc.name}}">{{otheracc.otherPaymentOptionName}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c8" >
                            <div class="label-sec">Amount</div>                        
                            <div class="payment-sh-sec">${{otheracc.paidAmount}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c8" >
                            <div class="label-sec">Paid Status</div>                        
                            <div class="pay-cheque-opt-view">
                                <span [ngClass]="{ 'paid' : otheracc.paymentStatus == 2, 'unpaid' : otheracc.paymentStatus != 2 }">{{ otheracc.paymentStatus == 2 ? 'Paid' : 'Unpaid' }}</span>                                    
                            </div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid On</div>                        
                            <div class="payment-sh-sec">{{otheracc.paidOnDate}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c8">
                            <div class="label-sec">Type</div>                        
                            <div class="payment-sh-sec">{{otheracc.invoiceType != undefined && otheracc.invoiceType != '' ? otheracc.invoiceType : 'Price Invoice'}}</div>
                        </div>
                    </div>
                </div>

                <div class="w-100" *ngIf="invoiceCardList && invoiceCardList.length>0">
                    <div class="payment-detail-box" *ngFor="let card of invoiceCardList">
                        <div class="w-100 pb-4">

                            <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Payment Method</div>
                            <div class="payment-sh-sec">Credit Card</div>
                        </div>                        
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Card Number</div>                        
                            <div class="payment-sh-sec">{{stripeInfoJsonArr && stripeInfoJsonArr.length>0 ? stripeInfoJsonArr[0].cardNumber : ''}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Card Type</div>  
                            <div class="payment-sh-sec" >{{stripeInfoJsonArr && stripeInfoJsonArr.length>0 ? stripeInfoJsonArr[0].cardBrand : ''}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Amount</div>                        
                            <div class="payment-sh-sec">${{card.amount}}</div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid Status</div>                        
                            <div class="pay-cheque-opt-view">
                                <span class="paid">Paid</span>                                    
                            </div>
                        </div>
                        

                        </div>
                         <div class="w-100">
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Payment Details</div>                        
                            <div class="payment-sh-sec blue-link cursor" (click)="openCardDetailPOPUP()">
                                <span>View Details</span>                                    
                            </div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Payment Gateway</div>                        
                            <div class="payment-sh-sec">
                                <img src="assets/images/repair-order/stripe-logo-payview.png">                                   
                            </div>
                        </div>
                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Type</div>                        
                            <div class="payment-sh-sec">{{card.invoiceType != undefined && card.invoiceType != '' ? card.invoiceType : 'Price Invoice'}}</div>
                        </div>

                        <div class="pay-w-col pay-w-c7">
                            <div class="label-sec">Paid On</div>                        
                            <div class="payment-sh-sec">{{card.transactionDate}}</div>
                        </div>

                        </div>
                    </div>
                </div>
                
            </div>            
        </div>
    </div>
</div>

<p-dialog
  [(visible)]="isUpdateBankName"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  class="pay-ro-modal pay-ro-modal-width"
>
  <ng-template pTemplate="header">
    <div
      class="w-100 mx-3"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <span style="font-size: 18px; font-weight: 500">Add Bank Name</span>
      <button
        pButton
        pRipple
        type="button"
        (click)="bankName != '' ? saveBtn() : false;"
        icon="pi pi-check"
        iconPos="right"
        label="SAVE"
        [ngClass] = "{ 'setOpacity5' : bankName == '' }"
        class="p-button-rounded p-button-danger float-right"
      ></button>
    </div>
  </ng-template>
  <div class="row my-3">
    <div class="col-12">
      <div>
        <label>
          <img
            src="assets/images/dispatch/svg/account-type-icon.png"
            alt="Bank Name"
            class="mr-2 new-request-icon"
          />
          <span style="color: #9b9a9a">Bank Name</span>
        </label>
        <span style="color: #b2b2b2; font-style: italic; float: right"
          >Required</span
        >
      </div>
      <div class="input-text-row form-group firstname">
        <input
          class="inputbox"
          matInput
          placeholder="Enter Bank Name"
          [(ngModel)]="bankName"
          maxlength="50"
        />
      </div>
    </div>

  </div>
</p-dialog>

<p-dialog
    styleClass="service-provider-address-popup service-provider-address-popup-roinvoicepage {{paymentLoading || paymentSuccessPopup ? 'cart-payment-loading-popup service-payment-loading-popup' : '' || paymentFailurePopup ? 'service-payment-failure-provider-popup cart-payment-loading-popup'  : ''}}"
    [modal]="true" [(visible)]="paymentLoading || paymentFailurePopup || paymentSuccessPopup"
    [draggable]="false">
    <div class="cart-svg-color-change" [hidden]="!paymentLoading">
        <img style="background-color: transparent !important;display: block;margin: 0 auto;" src="assets/images/service-provider/loading-animation-processing-payment.svg" onload="SVGInject(this)" />
        <div class="Completing-your-purchase">
            Payment processing..
        </div>
        <div class="Please-remain-on-the-page-and-do-not-close-your-browser-or-go">
            Please remain on the page and do not close your browser or go back until you see a confirmation.
        </div>
    </div>

    <div *ngIf="paymentFailurePopup" class="flex-column flex-center">
        <div class="cart-custom-failer-backgroud-color">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-end">
                <button style="background: transparent; border: none; box-shadow: none;" (click)="closePopup()" pButton
                    type="button" icon="pi pi-times" iconPos="left"></button>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-center margin-bottom-40px">
                    <img width="84px" height="84px" src="assets/images/service-provider/failed.png" />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-2 pb-3 flex-center margin-bottom-15px">
                    {{paymentMessage}}
                </div>
            </div>
        </div>
        <span class="w-100 " style="text-align: center; padding: 30px;">
            <button pButton type="button" (click)="tryAgain()"
                style="background: transparent;color: #fff;border-color: #444;padding: 4px 40px 7px;box-shadow: none;background-color: #444; border-radius: 20px;"
                label="Try Again"></button>
        </span>
    </div>

    <div *ngIf="paymentSuccessPopup" class="flex-column flex-center">
        <div class="cart-custom-success-backgroud-color">
            <!--div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-end">
                <button style="background: transparent; border: none; box-shadow: none;" (click)="successClose()" pButton
                    type="button" icon="pi pi-times" iconPos="left"></button>
            </div-->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-center mt-4 mb-4">
                    <img width="84px" height="84px" src="assets/images/gts/tick.png" />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-center" style="font-size: 18px;">
                    Payment Successful
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-center mt-2">
                    Receipt has been emailed to
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding flex-center mb-4">
                    {{paymentSuccessText5}}
                </div>
            </div>
        </div> 
        <div class="cart-custom-white-backgroud-color">
            <div class="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 p-0 m-0 text-left">
                     <div class="cart-custom-popup-label">Amount</div>
                    <div class="cart-custom-popup-cont">${{paymentSuccessText4}}</div>
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 p-0 m-0 text-right">
                     <div class="cart-custom-popup-label">Transaction Number</div>
                    <div class="cart-custom-popup-cont">{{paymentSuccessText1}}</div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 p-0 m-0 text-left">
                     <div class="cart-custom-popup-label">Invoice ID</div>
                    <div class="cart-custom-popup-cont">{{paymentSuccessText2}}</div> 
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 p-0 m-0 text-right">
                     <div class="cart-custom-popup-label">Collabtic Transaction ID#</div>
                    <div class="cart-custom-popup-cont">{{paymentSuccessText3}}</div>
                </div>            
                
                
            </div>
        </div>
        <span class="w-100 " style="background-color: #fff;text-align: center; padding: 20px; border-top:1px solid #ececec;">
            <button pButton type="button" (click)="successClose()"                
                style="background: transparent;color: #fff;border-color: #469073;padding: 4px 40px 7px;box-shadow: none;background-color: #469073; border-radius: 20px;"
                label="Close">
                <!--img width="12px" height="12px" src="assets/images/repair-order/pay-ss-close.png" /-->
            </button>
        </span>       
    </div>
</p-dialog>
<p-dialog
    styleClass="view-card-details-popup"
    [modal]="true" [(visible)]="viewCardDetailPOPUP"
    [draggable]="false">
    <ng-template pTemplate="header">
        <div class="w-100 mx-3" style="display: flex; align-items: center; justify-content: space-between">
          <span style="font-size: 18px; font-weight: 500">Payment Details</span>          
        </div>
    </ng-template>
    <div class="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-1">Amount</span>
                <span class="detail-popup-cont">${{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].amount : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-2">Balance Transaction</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].balanceTransaction : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-3">CC Number</span>
                <span class="detail-popup-cont">{{stripeInfoJsonArr && stripeInfoJsonArr.length>0 ? stripeInfoJsonArr[0].cardNumber : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-4">Card Type</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].cardInfo.cardType : ''}}</span>
            </div>           
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-5">CC Expiration Month</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].cardInfo.ccExpireMonth : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-6">CC Expiration Year</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].cardInfo.ccExpireYear : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-7">Currency</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].currency : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-8">Created</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].transactionDatePOPUP : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-9">Id</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].transactionId : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-10">Payment Method</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].paymentMethod : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 pl-0 de-bottom-border">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-11">Receipt Url</span>
                <span class="detail-popup-cont blue-link cursor" (click)="receiptURL()">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].receiptUrl : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 pl-0">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-12">Status</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].status : ''}}</span>
            </div>            
        </div>
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 pl-0">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 m-0">
                <span class="detail-popup-label bg-13">Error</span>
                <span class="detail-popup-cont">{{invoiceCardList && invoiceCardList.length>0 ? invoiceCardList[0].error : ''}}</span>
            </div>            
        </div>
    </div>
</p-dialog>